import React, { useState, FormEvent, ChangeEvent } from "react";
import Grid from "@mui/material/Grid";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Link, useNavigate } from "react-router-dom";


interface LoginForm {
  email: string;
  password: string;
  remember: boolean;
}

const LoginPage: React.FC = () => {
  const navigate = useNavigate();

  const [value, setValue] = useState<LoginForm>({
    email: "user@gmail.com",
    password: "123456",
    remember: false,
  });

  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
    })
  );

  const changeHandler = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setValue({ ...value, [e.target.name]: e.target.value });
    validator.showMessages();
  };

  const rememberHandler = (): void => {
    setValue({ ...value, remember: !value.remember });
  };

  const submitForm = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();

    if (validator.allValid()) {
      const userRegex = /^user+.*/gm;
      const { email } = value;

      if (email.match(userRegex)) {
        toast.success("You successfully logged in to Bohu!");
        navigate("/home");
      } else {
        toast.error("Invalid email format!");
      }

      setValue({
        email: "",
        password: "",
        remember: false,
      });
      validator.hideMessages();
    } else {
      validator.showMessages();
      toast.error("All fields are required!");
    }
  };

  return (
    <Grid className="loginWrapper">
      <Grid className="loginForm">
        <h2>Sign In</h2>
        <p>Sign in to your account</p>

        <form onSubmit={submitForm} noValidate>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                className="inputOutline"
                fullWidth
                placeholder="E-mail"
                value={value.email}
                variant="outlined"
                name="email"
                label="E-mail"
                InputLabelProps={{ shrink: true }}
                onBlur={changeHandler}
                onChange={changeHandler}
              />
              {validator.message("email", value.email, "required|email")}
            </Grid>

            <Grid item xs={12}>
              <TextField
                className="inputOutline"
                fullWidth
                placeholder="Password"
                value={value.password}
                variant="outlined"
                name="password"
                type="password"
                label="Password"
                InputLabelProps={{ shrink: true }}
                onBlur={changeHandler}
                onChange={changeHandler}
              />
              {validator.message("password", value.password, "required")}
            </Grid>

            <Grid item xs={12}>
              <Grid className="formAction">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={value.remember}
                      onChange={rememberHandler}
                    />
                  }
                  label="Remember Me"
                />
                <Link to="/forgot">Forgot Password?</Link>
              </Grid>

              <Grid className="formFooter">
                <Button fullWidth className="cBtnTheme" type="submit">
                  Login
                </Button>
              </Grid>

              <Grid className="loginWithSocial">
                <Button className="facebook" aria-label="Login with Facebook">
                  <i className="fa fa-facebook"></i>
                </Button>
                <Button className="twitter" aria-label="Login with Twitter">
                  <i className="fa fa-twitter"></i>
                </Button>
                <Button className="linkedin" aria-label="Login with LinkedIn">
                  <i className="fa fa-linkedin"></i>
                </Button>
              </Grid>

              <p className="noteHelp">
                Don’t have an account?{" "}
                <Link to="/register">Create a free account</Link>
              </p>
            </Grid>
          </Grid>
        </form>

        <div className="shape-img">
          <i className="fi flaticon-honeycomb"></i>
        </div>
      </Grid>
    </Grid>
  );
};

export default LoginPage;
